const defaultRoles = [
  "view_dashboard",
  "view_activity_log",
  "export_activity_log",
  "view_user",
  "verify_kyc",
  "approve_kyc",
  "reject_kyc",
  "delete_user",
  "suspend_user",
  "unsuspend_user",
  "export_details",
  "view_transaction",
  "export_transaction",
  "generate_transaction_reciept",
  "view_report",
  "share_report",
  "export_report",
  "create_team_member",
  "edit_team_member",
  "view_team_member",
  "delete_team_member",
  "create_roles",
  "edit_roles",
  "view_roles",
  "delete_roles",
  "set_exchange_rate",
  "view_exchange_rate",
  "edit_exchange_rate",
  "delete_exchange_rate",
  "view_third_party",
] as const;

// DO NOT ADJUST THE LIST OF PERMISSION CALLED UP ^^^^^
// IF YOU WISH TO ADD TO THE PERMISSION CREATE ANOTHER ARRAY AND PASS IT TO THE EXPORT BELOW

const extendRoles = [
  "transfer_between_wallets",
  "set_remittance_rule",
  "update_remittance_rule",
  "view_remittance_rule",
  "view_template",
  "create_edit_template",
  "delete_template",
  "download_template",
  "view_customer_doc",
  "upload_customer_doc",
  "comment_on_customer_doc",
  "view_third_party_vendor_control",
  "delete_third_party_vendor_control",
  "edit_third_party_vendor_control",
  "create_third_party_vendor_control",
  "view_ledger",
  "export_ledger",
  "set_referral_setting",
  "view_referral_setting",
  "edit_referral_setting",
  "delete_referral_setting",
  "create_promotion",
  "edit_promotion",
  "view_promotion",
  "delete_promotion",
  "publish_promotion",
  "approve_influencer_contract",
  "reject_influencer_contract",
  "terminate_influencer_contract",
  "view_influencer_contract",
  "restore_user",
  "view_approval_setting",
  "edit_approval_setting",
] as const;

export const systemRoles = [...defaultRoles, ...extendRoles] as const;

// Rate Intelligence exposes competitor-sensitive pricing/alert data — access
// is restricted to these roles on top of (not instead of) the normal
// view/create/edit/delete_rate_alert permission checks, since relying on
// permissions alone assumes every role's permission assignment is correct.
export const RATE_INTELLIGENCE_ALLOWED_ROLES = ["super_admin", "finance"];

export function hasRateIntelligenceRole(user: any): boolean {
  return !!user?.roles?.some((role: string) =>
    RATE_INTELLIGENCE_ALLOWED_ROLES.includes(role),
  );
}
